import { render } from "./Config.vue?vue&type=template&id=9fdcf4c6&scoped=true"
import script from "./Config.vue?vue&type=script&lang=js"
export * from "./Config.vue?vue&type=script&lang=js"

import "./Config.vue?vue&type=style&index=0&id=9fdcf4c6&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-9fdcf4c6"

export default script